import { useDispatch } from 'react-redux';
import useSelectedContactId from './useSelectedContactId';

const useSubContacts = () => {
  const selectedContactId = useSelectedContactId();
  const dispatch = useDispatch();

  const create = ({ contactId, firstName, lastName, dateOfBirth }) =>
    dispatch.chatContacts.createSubContact({
      mainContactId: contactId || selectedContactId,
      firstName,
      lastName,
      dateOfBirth,
    });

  return { create };
};

export default useSubContacts;
